"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAttendeeUsedBackgroundFilterSLI = void 0;
var _react = require("react");
var _react2 = require("../../client/react");
/**
 * This function tracks the background filter used for attendees
 * @param filterType
 * @param chimeAttendeeId
 */
var useAttendeeUsedBackgroundFilterSLI = exports.useAttendeeUsedBackgroundFilterSLI = function useAttendeeUsedBackgroundFilterSLI(_ref) {
  var userBackground = _ref.userBackground,
    chimeAttendeeId = _ref.chimeAttendeeId;
  var _useBackgroundFilterP = (0, _react2.useBackgroundFilterPageActionsApi)(),
    attendeeUsedBackgroundFilter = _useBackgroundFilterP.attendeeUsedBackgroundFilter;
  (0, _react.useEffect)(function () {
    if (!chimeAttendeeId) return;
    attendeeUsedBackgroundFilter({
      chimeAttendeeId: chimeAttendeeId,
      filterType: userBackground
    });
  }, [userBackground, chimeAttendeeId]);
};